declare let Imserso:
    | {
        postForm: (action: string, obj: any, modal: boolean, target: any) => void;
      }
    | undefined;

export default function doPostRequest(url: string, data: object): void {
    if (typeof Imserso !== "undefined") {
        try {
            Imserso.postForm(
                url,
                /* Object debe ser el objecto directo, no un String JSON. */
                data,
                false,
                null);
        } catch {
        }
    }
}
